import { z } from "zod";
import { date } from "@/lib/date";

export const createSaleSchema = z
  .object({
    name: z.string().min(1, "Campo obrigatório!"),
    description: z.string().min(1, "Campo obrigatório!"),
    isActive: z.boolean().optional(),
    startDate: z.preprocess(
      (val) =>
        val
          ? date(val as string)
              .startOf("day")
              .toDate()
          : null,
      z.date("Insira uma data válida!"),
    ),
    endDate: z.preprocess(
      (val) =>
        val
          ? date(val as string)
              .endOf("day")
              .toDate()
          : null,
      z.date("Insira uma data válida!"),
    ),
    createdAt: z.preprocess(
      (val) => (val ? date(val as string).toDate() : date().toDate()),
      z.date().optional().default(date().toDate()),
    ),
    updatedAt: z.preprocess(
      (val) => (val ? date(val as string).toDate() : date().toDate()),
      z.date().optional().default(date().toDate()),
    ),
  })
  .refine((data) => date(data.startDate).isBefore(date(data.endDate)), {
    message: "A data de início deve ser anterior à data de término",
    path: ["endDate"],
  })
  .refine(
    (data) => date(data.endDate).startOf("day").isAfter(date().startOf("day")),
    {
      message: "A data de término deve ser posterior à data atual",
      path: ["endDate"],
    },
  );

export const updateSaleSchema = z
  .object({
    name: z.optional(z.string().min(1, "Campo obrigatório!")),
    description: z.string().min(1, "Campo obrigatório!"),
    isActive: z.boolean().optional(),
    startDate: z.optional(
      z.preprocess(
        (val) =>
          val
            ? date(val as string)
                .startOf("day")
                .toDate()
            : null,
        z.date("Insira uma data válida!"),
      ),
    ),
    endDate: z.optional(
      z.preprocess(
        (val) =>
          val
            ? date(val as string)
                .endOf("day")
                .toDate()
            : null,
        z.date("Insira uma data válida!"),
      ),
    ),
    updatedAt: z.preprocess(
      (val) => (val ? date(val as string).toDate() : date().toDate()),
      z.date().optional().default(date().toDate()),
    ),
  })
  .refine(
    (data) => {
      if (!data.startDate || !data.endDate) return true;
      return date(data.startDate).isBefore(date(data.endDate));
    },
    {
      message: "A data de início deve ser anterior à data de término",
      path: ["endDate"],
    },
  )
  .refine(
    (data) => {
      return date(data.endDate).startOf("day").isAfter(date().startOf("day"));
    },
    {
      message: "A data de término deve ser posterior à data atual",
      path: ["endDate"],
    },
  );

export type CreateSaleSchema = z.infer<typeof createSaleSchema>;
export type UpdateSaleSchema = z.infer<typeof updateSaleSchema>;
